/* eslint-disable max-len */
import React, {useState, useEffect,useContext} from 'react'
import moment from 'moment'
import { motion } from 'framer-motion';
import RequestToReturnModal from './Modals/RequestToReturnModal'
import VirtualPaymentModal from './Modals/VirtualPaymentModal'
import ViewInvoice from './ViewInvoice'
import { GenerateDateandTime, GenerateDateFormat, generateDateWithTime } from '../../redux/helper/DateConverter'
import { distributorService } from '../../service/distributor.service'
import { PriceHandler } from '../../redux/helper/CamelCase'
import HeaderContext from '../../Components/Context/HeaderContext';
import { AccessPrevilegesFunction } from '../../constants/globalPrivilegesFunction';


const InvoiceList = ({invoicesList, isEditId, setisEditId,sort, setsort,viewInvoice,setViewInvoice}) => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [viewModalPopup, setViewModalPopup] = useState(false)
    const [returnRequestModal, setReturnRequestModal] = useState(false)
    const [virtualPaymentModal, setVirtualPaymentModal] = useState(false)
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState(null)
    const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState([])
    const [threeDotsLoader, setThreeDotsLoader] = useState(false)
    const [requestData, setRequestData] = useState({
        reason:'',
        attached_file:[],
    })

    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;

    const privilagesAssigned = AccessPrevilegesFunction('return_order')

    const  handleViewInvoiceDetails = async (invoiceNumber) => {
        setViewModalPopup(true)
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        setViewInvoiceDetails(res.data.data)
    }

    const handleReturnToRequest = async (item) => {
        setReturnRequestModal(true)
        setSelectedInvoiceNumber(item) 
    }

    const ProceedreturnRequest = async () => {
        setThreeDotsLoader(true);
        const payload = {
            return_request_note:requestData.return_request_note,
            return_request_atachment:requestData.attached_file,
            return_request_status: true
        }
        const returnResponse = await distributorService.UpdateInvoiceList(selectedInvoiceNumber.INVOICE_NO,selectedInvoiceNumber?.INDENT_NUMBER, payload)
        if(returnResponse.error === true){
            setReturnRequestModal(false)
            SetErrorMessage(returnResponse.data.message)
            setcolorValue('red')
            setTimeout(() => {
                SetErrorMessage('') 
                setcolorValue('')              
            }, 1000);
            setThreeDotsLoader(false);
        } else {
            setReturnRequestModal(false)
            SetSuccessMessage('Return request submitted successfuly')
            setTimeout(() => {
                SetSuccessMessage('') 
                setcolorValue('')              
            }, 1000);
            setThreeDotsLoader(false);

        }
    }
  
    return (
        <>
            <div className="overflow-auto mt-[18px] pb-7 relative" style={{height:'calc(100vh - 293px)'}}>
                <table className="w-full table-auto relative">
                    <thead className="sticky top-0 left-0" style={{zIndex: '6', opacity: '1', transform: 'none'}}>
                        <tr className="bg-[#555259] h-10">
                            <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[132px] bg-[#555259]" scope="col">
                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                    Invoice No.
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[145px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center w-[125px]">
                                    E-waybill No.
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Invoice Date
                                    <a href="javascript:void(0)" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sort === 'LAST_UPDATE_DATE+asc' ? 180 : 0 }}
                                            className={`${sort === 'LAST_UPDATE_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sort === 'LAST_UPDATE_DATE+asc') {
                                                    setsort('LAST_UPDATE_DATE+desc');
                                                } else if (sort === 'LAST_UPDATE_DATE+desc') {
                                                    setsort('LAST_UPDATE_DATE+asc');
                                                } else {
                                                    setsort('LAST_UPDATE_DATE+asc');
                                                }
                                                // setCurrentPage(1);
                                                // setLoading(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[177px] text-center flex justify-center items-center">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Order Category
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[220px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transporter Name
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center w-[125px]">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Order Date
                                    <a href="javascript:void(0)" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sort === 'ORDER_ACCEPTANCE_DATE+asc' ? 180 : 0 }}
                                            className={`${sort === 'ORDER_ACCEPTANCE_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sort === 'ORDER_ACCEPTANCE_DATE+asc') {
                                                    setsort('ORDER_ACCEPTANCE_DATE+desc');
                                                } else if (sort === 'ORDER_ACCEPTANCE_DATE+desc') {
                                                    setsort('ORDER_ACCEPTANCE_DATE+asc');
                                                } else {
                                                    setsort('ORDER_ACCEPTANCE_DATE+asc');
                                                }
                                                // setCurrentPage(1);
                                                // setLoading(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Shipped from
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Shipped to
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[170px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-center items-center">
                                    Invoice Value
                                    <a href="javascript:void(0)" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sort === 'TOTAL_INVOICE_AMT+asc' ? 180 : 0 }}
                                            className={`${sort === 'TOTAL_INVOICE_AMT+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sort === 'TOTAL_INVOICE_AMT+asc') {
                                                    setsort('TOTAL_INVOICE_AMT+desc');
                                                } else if (sort === 'TOTAL_INVOICE_AMT+desc') {
                                                    setsort('TOTAL_INVOICE_AMT+asc');
                                                } else {
                                                    setsort('TOTAL_INVOICE_AMT+asc');
                                                }
                                                // setCurrentPage(1);
                                                // setLoading(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[162px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center w-[125px]">
                                    Payment Status
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-2.5 px-7 min-w-[60px]">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoicesList.length>0 && invoicesList.map((item, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={i}>
                                {item?.TRX_NUMBER === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    :<td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        {item?.TRX_NUMBER}                       
                                    </td>  
                                } 
                                {item?.WAYBILL_NUMBER === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    :<td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        {item?.WAYBILL_NUMBER}                       
                                    </td>  
                                } 
                                {item?.INVOICE_DATE === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    :<td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        {moment(item?.INVOICE_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('DD-MMM-YYYY, HH:mm:ss')}                       
                                    </td>  
                                }                                   
                                {item?.ORDER_CATEGORY === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    : <td className="text-sm font-normal py-2.5 px-7 text-center">{item?.ORDER_CATEGORY}</td>
                                }
                                {item?.TRANSPORTER_NAME === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    : <td className="text-sm font-normal py-2.5 px-7 text-center">{item?.TRANSPORTER_NAME}</td>
                                }
                                {item?.INDENT_NUMBER === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">-</td> 
                                    : <td className="text-sm font-normal py-2.5 px-7 text-center">{item?.INDENT_NUMBER}</td>
                                }
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {moment(item?.ORDER_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('DD-MMM-YYYY, HH:mm:ss')}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.SHIP_FROM}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {item?.SHIP_TO}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                    {PriceHandler(item?.INVOICE_VALUE)}
                                </td>
                                {item?.PAYMENT_STATUS === null 
                                    ? <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">PENDING</td> 
                                    : <td className="text-sm font-normal py-2.5 px-7 text-center">{item?.PAYMENT_STATUS}</td>
                                }
                                <td 
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                    className="py-2.5 px-7 sticky right-0 bg-[#ffffffe6] z-[1] cursor-pointer" style={{background: "rgba(255, 255, 255, 0.45)", backdropFilter: "blur(5.5px)"}}>
                                    <div className="dropdown relative">
                                        <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer"/>
                                        </button>
                                        {isEditId !== '' && (
                                            <ul className={`dropdown-menu min-w-max absolute ${isEditId === i ? 'show' : 'hidden'} top-0 right-12 bg-[#FFFFFF] rounded-[10px] shadow-s2`} aria-labelledby="dropdownMenuButton111">
                                                <li 
                                                    className="px-5 pb-1.5 pt-5" 
                                                    data-bs-toggle="modal" 
                                                    data-bs-target="#view-download-pending">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"  href="#" 
                                                        onClick={() => handleViewInvoiceDetails(item.INVOICE_NO)}>
                                                        View and Download
                                                    </a>
                                                </li>
                                                <li className="px-5 py-1.5">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href='#'
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#virtualPayment" 
                                                        onClick={() => setVirtualPaymentModal(true)}>
                                                        Pay
                                                    </a>
                                                </li>
                                                {(!item?.PAYMENT_STATUS?.includes('RETURN') && privilagesAssigned) && <li className="px-5 pt-1.5 pb-5" data-bs-toggle="modal" data-bs-target="#Return-Order-Request">
                                                    <a 
                                                        className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="#" 
                                                        onClick={() => handleReturnToRequest(item)}>
                                                        Request to Return
                                                    </a>
                                                </li>
                                                }
                                            </ul>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {viewModalPopup && viewInvoiceDetails !== null && <ViewInvoice 
                    viewModalPopup={viewModalPopup} 
                    setViewModalPopup={setViewModalPopup}  
                    viewInvoiceDetails={viewInvoiceDetails} 
                    setViewInvoiceDetails={setViewInvoiceDetails}
                />}
                {returnRequestModal && <RequestToReturnModal 
                    returnRequestModal={returnRequestModal} 
                    setReturnRequestModal={setReturnRequestModal} 
                    viewInvoiceDetails={viewInvoiceDetails} 
                    selectedInvoiceNumber={selectedInvoiceNumber}
                    requestData={requestData}
                    setRequestData={setRequestData}
                    handleReturnToRequest={handleReturnToRequest}
                    ProceedreturnRequest={ProceedreturnRequest}
                    threeDotsLoader={threeDotsLoader}
                    setThreeDotsLoader={setThreeDotsLoader}
                />}
                {virtualPaymentModal && <VirtualPaymentModal virtualPaymentModal={virtualPaymentModal} setVirtualPaymentModal={setVirtualPaymentModal} />}
            </div>
      
        </>
    )
}

export default InvoiceList
